import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles<Theme>((theme) => ({
  block: {
    width: "100%",
  },
  title: {
    marginBottom: 16,
    '@media (max-width: 768px)': {
      marginBottom: 24,
    }
  },
  content: {
    width: "100%",
    maxWidth: 928,
  },
  field: {
    width: 220,
    maxWidth: 220,
    '& > div': {
      marginBottom: 0,
    },
    '&:last-of-type': {
      marginRight: 0,
    },

    '@media (max-width: 768px)': {
      marginRight: 0,
      marginBottom: 16,
      maxWidth: '100%',
      width: "100%",
    }
  },
  fieldSmall: {
    width: 145,
    maxWidth: 145,
    '& > div': {
      marginBottom: 0,
    },
    '&:last-of-type': {
      marginRight: 0,
    },

    '@media (max-width: 768px)': {
      marginRight: 0,
      marginBottom: 16,
      maxWidth: '100%',
      width: "100%",
    }
  },
  fieldLarge: {
    width: 456,
    maxWidth: 456,
    '& > div': {
      marginBottom: 0,
    },
    '&:last-of-type': {
      marginRight: 0,
    },

    '@media (max-width: 768px)': {
      marginRight: 0,
      marginBottom: 16,
      maxWidth: '100%',
      width: "100%",
    }
  },
  datepicker: {
    height: 40,
    '& .MuiOutlinedInput-input': {
      padding: '9px 50px 8px 12px'
    },
    '& .PrivatePickersMonth-root:disabled': {
      color: theme.palette.action.disabled,
    },
  },
  form: {
    display: "flex",
    flexWrap: "wrap",
    gap: 16,

    '@media (max-width: 768px)': {
      flexDirection: "column",
      gap: 0,
    }
  },
  actions: {
    '& button': {
      height: 40,
      width: 220,
      '@media (max-width: 768px)': {
        width: '100%'
      }
    }
  }
}));
